(() => {
  const STORAGE_KEYS = {
  interests: 'cdVaultInterests',
  sessionSeen: 'cdVaultSessionSeen'
};

  function initializeVault(vault) {
    if (vault.dataset.vaultInitialized === 'true') {
      return;
    }

    vault.dataset.vaultInitialized = 'true';

    const modal =
      vault.querySelector('[data-vault-modal]');

    const panel =
      vault.querySelector('[data-vault-panel]');

    const floatingTab =
      vault.querySelector('.cd-vault__tab');

    const closeButtons =
      vault.querySelectorAll('[data-vault-close]');

    const interestButtons = Array.from(
      vault.querySelectorAll('[data-vault-interest]')
    );

    const continueButton =
      vault.querySelector('[data-vault-continue]');

    const backButton =
      vault.querySelector('[data-vault-back]');

    const selectionError =
      vault.querySelector('[data-vault-selection-error]');

    const tagsInput =
      vault.querySelector('[data-vault-tags]');

    const selectedSummary =
      vault.querySelector('[data-vault-selected-summary]');

    const emailInput =
      vault.querySelector('#CDVaultEmail');

    const success =
      vault.querySelector('[data-vault-success]');

    const stepOne =
      vault.querySelector('[data-vault-step="1"]');

    const stepTwo =
      vault.querySelector('[data-vault-step="2"]');

    const stepOneHeading =
      vault.querySelector('[data-vault-heading]');

    if (!modal || !panel) {
      return;
    }

    const showDelay =
      Number(vault.dataset.showDelay || 8000);

    const scrollTrigger =
      Number(vault.dataset.scrollTrigger || 30) / 100;

    const selectedInterests =
      new Set();

    const interestLabels = {
      masks: 'Masks',
      merch: 'Merch',
      archive: 'The Archive'
    };

    let tabHasBeenShown = false;
    let lastFocusedElement = null;

    /* =====================================
       INTEREST STORAGE
    ===================================== */

    function hasSeenVaultThisSession() {
  try {
    return sessionStorage.getItem(STORAGE_KEYS.sessionSeen) === 'true';
  } catch (error) {
    return false;
  }
}

function markVaultSeenThisSession() {
  try {
    sessionStorage.setItem(STORAGE_KEYS.sessionSeen, 'true');
  } catch (error) {
    // Vault still works if session storage is unavailable.
  }
}

    function saveInterests() {
      try {
        localStorage.setItem(
          STORAGE_KEYS.interests,
          JSON.stringify(
            Array.from(selectedInterests)
          )
        );
      } catch (error) {
        // Vault still works if storage is unavailable.
      }
    }

    function loadInterests() {
      try {
        const saved =
          JSON.parse(
            localStorage.getItem(
              STORAGE_KEYS.interests
            ) || '[]'
          );

        if (!Array.isArray(saved)) {
          return;
        }

        saved.forEach((interest) => {
          if (interestLabels[interest]) {
            selectedInterests.add(interest);
          }
        });

      } catch (error) {
        try {
          localStorage.removeItem(
            STORAGE_KEYS.interests
          );
        } catch (storageError) {
          // Do nothing.
        }
      }
    }

    function updateInterestUI() {
      interestButtons.forEach((button) => {
        const interest =
          button.dataset.vaultInterest;

        const isSelected =
          selectedInterests.has(interest);

        button.classList.toggle(
          'is-selected',
          isSelected
        );

        button.setAttribute(
          'aria-pressed',
          isSelected ? 'true' : 'false'
        );
      });

      const tags = [
        'newsletter',
        'vault'
      ];

      selectedInterests.forEach((interest) => {
        tags.push(
          `vault-${interest}`
        );
      });

      if (tagsInput) {
        tagsInput.value =
          tags.join(',');
      }

      if (selectedSummary) {
        const labels =
          Array.from(selectedInterests)
            .map(
              (interest) =>
                interestLabels[interest]
            )
            .filter(Boolean);

        selectedSummary.textContent =
          labels.length
            ? `Selected: ${labels.join(' • ')}`
            : '';
      }
    }

    /* =====================================
       SCREEN NAVIGATION
    ===================================== */

    function showStep(step) {
      if (stepOne) {
        stepOne.hidden =
          step !== 1;

        stepOne.classList.toggle(
          'is-active',
          step === 1
        );
      }

      if (stepTwo) {
        stepTwo.hidden =
          step !== 2;

        stepTwo.classList.toggle(
          'is-active',
          step === 2
        );
      }

      window.setTimeout(() => {
        if (step === 1) {
          stepOneHeading?.focus();
        }

        if (step === 2) {
          emailInput?.focus();
        }
      }, 80);
    }

    /* =====================================
       FLOATING TRIGGER
    ===================================== */

    function showTab() {
      if (
        tabHasBeenShown ||
        !floatingTab
      ) {
        return;
      }

      tabHasBeenShown = true;

      floatingTab.classList.add(
        'is-visible'
      );
    }

    /* =====================================
       OPEN / CLOSE
    ===================================== */

    function openVault() {
      markVaultSeenThisSession();
      lastFocusedElement =
        document.activeElement;

      modal.classList.add(
        'is-open'
      );

      modal.setAttribute(
        'aria-hidden',
        'false'
      );

      document
        .querySelectorAll('[data-vault-open]')
        .forEach((trigger) => {
          trigger.setAttribute(
            'aria-expanded',
            'true'
          );
        });

      document.body.classList.add(
        'cd-vault-open'
      );

      window.setTimeout(() => {
        if (success) {
          success.focus();
          return;
        }

        if (
          stepTwo &&
          !stepTwo.hidden
        ) {
          emailInput?.focus();
          return;
        }

        stepOneHeading?.focus();

      }, 80);
    }

    function closeVault() {
      modal.classList.remove(
        'is-open'
      );

      modal.setAttribute(
        'aria-hidden',
        'true'
      );

      document
        .querySelectorAll('[data-vault-open]')
        .forEach((trigger) => {
          trigger.setAttribute(
            'aria-expanded',
            'false'
          );
        });

      document.body.classList.remove(
        'cd-vault-open'
      );

      /*
        Clean #vault out of the address bar
        without reloading the page.
      */
      if (window.location.hash === '#vault') {
        history.replaceState(
          null,
          '',
          window.location.pathname +
            window.location.search
        );
      }

      if (
        lastFocusedElement instanceof
        HTMLElement
      ) {
        lastFocusedElement.focus();
      }
    }

    /* =====================================
       ACCESSIBILITY
    ===================================== */

    function getFocusableElements() {
      return Array.from(
        panel.querySelectorAll(
          [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
          ].join(',')
        )
      ).filter(
        (element) =>
          element.offsetParent !== null
      );
    }

    /* =====================================
       INITIAL STATE
    ===================================== */

    loadInterests();
    updateInterestUI();

    /* =====================================
       GLOBAL VAULT LINKS

       Supports:
       data-vault-open
       href="#vault"
    ===================================== */

    document.addEventListener(
      'click',
      (event) => {
        const vaultTrigger =
          event.target.closest(
            '[data-vault-open], a[href="#vault"]'
          );

        if (!vaultTrigger) {
          return;
        }

        event.preventDefault();

        openVault();
      }
    );

    /*
      Also supports arriving on a URL
      that already ends in #vault.
    */
    function handleVaultHash() {
      if (
        window.location.hash.toLowerCase() ===
        '#vault'
      ) {
        openVault();
      }
    }

    window.addEventListener(
      'hashchange',
      handleVaultHash
    );

    /* =====================================
       CLOSE CONTROLS
    ===================================== */

    closeButtons.forEach((button) => {
      button.addEventListener(
        'click',
        closeVault
      );
    });

    /* =====================================
       INTEREST BUTTONS
    ===================================== */

    interestButtons.forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          const interest =
            button.dataset.vaultInterest;

          if (!interest) {
            return;
          }

          if (
            selectedInterests.has(interest)
          ) {
            selectedInterests.delete(
              interest
            );
          } else {
            selectedInterests.add(
              interest
            );
          }

          saveInterests();
          updateInterestUI();

          if (selectionError) {
            selectionError.hidden = true;
          }
        }
      );
    });

    /* =====================================
       CONTINUE TO EMAIL
    ===================================== */

    continueButton?.addEventListener(
      'click',
      () => {
        if (!selectedInterests.size) {
          if (selectionError) {
            selectionError.hidden = false;
          }

          interestButtons[0]?.focus();

          return;
        }

        saveInterests();
        updateInterestUI();

        showStep(2);
      }
    );

    /* =====================================
       BACK TO INTERESTS
    ===================================== */

    backButton?.addEventListener(
      'click',
      () => {
        showStep(1);
      }
    );

    /* =====================================
       KEYBOARD / FOCUS TRAP
    ===================================== */

    modal.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape') {
          closeVault();
          return;
        }

        if (event.key !== 'Tab') {
          return;
        }

        const focusableElements =
          getFocusableElements();

        if (!focusableElements.length) {
          return;
        }

        const firstElement =
          focusableElements[0];

        const lastElement =
          focusableElements[
            focusableElements.length - 1
          ];

        if (
          event.shiftKey &&
          document.activeElement ===
            firstElement
        ) {
          event.preventDefault();
          lastElement.focus();
        }

        if (
          !event.shiftKey &&
          document.activeElement ===
            lastElement
        ) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    );

    /* =====================================
       SHOPIFY SUCCESS / ERROR
    ===================================== */

    if (success) {
      openVault();
    }

    const formError =
      vault.querySelector(
        '[data-vault-form-error]'
      );

    if (formError) {
      showStep(2);
      openVault();
    }

    /* =====================================
       ENGAGEMENT TRIGGERS
    ===================================== */

    window.setTimeout(
      showTab,
      showDelay
    );

    function handleScroll() {
      const scrollableHeight =
        document.documentElement.scrollHeight -
        window.innerHeight;

      if (scrollableHeight <= 0) {
        return;
      }

      const scrollProgress =
        window.scrollY /
        scrollableHeight;

      if (
        scrollProgress >=
        scrollTrigger
      ) {
        showTab();

        window.removeEventListener(
          'scroll',
          handleScroll
        );
      }
    }

    window.addEventListener(
      'scroll',
      handleScroll,
      {
        passive: true
      }
    );

   /*
  Auto-open once per browser session.
*/
if (
  !hasSeenVaultThisSession() &&
  window.location.hash.toLowerCase() !== '#vault'
) {
  window.setTimeout(() => {
    if (
      !hasSeenVaultThisSession() &&
      !modal.classList.contains('is-open')
    ) {
      openVault();
    }
  }, 4000);
}

/*
  Check last so all Vault
  functionality is initialized first.
*/
handleVaultHash();

  }

  /* =======================================
     INITIALIZE
  ======================================= */

  function initializeAllVaults() {
    document
      .querySelectorAll('[data-cd-vault]')
      .forEach(initializeVault);
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllVaults
    );
  } else {
    initializeAllVaults();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeAllVaults
  );
})();